<template>
  <Transition name="season-reward-toast">
    <output v-if="lines.length > 0" class="season-reward-toast">
      <p v-for="(line, i) in lines" :key="i" class="copy">{{ line }}</p>
    </output>
  </Transition>
</template>

<script setup lang="ts">
import { computed, onUnmounted, watch } from 'vue'
import { useI18n } from '../i18n/t'
import {
  ackSeasonNotice,
  seasonNoticeItems,
} from '../account/seasonNotice'

const TOAST_MS = 8_000

const { t } = useI18n()
const lines = computed(() =>
  seasonNoticeItems.value.map((item) =>
    item.kind === 'final'
      ? t('seasonReward.final', {
          league: t(`rank.leagues.${item.league}`),
          n: item.packs,
        })
      : t('seasonReward.start'),
  ),
)
let hideTimer: ReturnType<typeof setTimeout> | null = null

function clearTimer(): void {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
}

watch(
  seasonNoticeItems,
  (items) => {
    clearTimer()
    if (items.length === 0) return
    void ackSeasonNotice()
    hideTimer = setTimeout(() => {
      seasonNoticeItems.value = []
    }, TOAST_MS)
  },
  { immediate: true },
)

onUnmounted(() => {
  clearTimer()
})
</script>

<style scoped>
.season-reward-toast {
  position: fixed;
  left: 50%;
  bottom: calc(212px + env(safe-area-inset-bottom, 0px));
  z-index: 10050;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: min(520px, calc(100vw - 32px));
  margin: 0;
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--md-sys-color-surface-container-high);
  color: var(--md-sys-color-on-surface);
  box-shadow: var(--md-elevation-2);
  transform: translateX(-50%);
  font-family: Roboto, system-ui, sans-serif;
}

.copy {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}

.season-reward-toast-enter-active,
.season-reward-toast-leave-active {
  transition:
    opacity var(--md-motion-short) var(--md-motion-standard),
    transform var(--md-motion-short) var(--md-motion-standard);
}

.season-reward-toast-enter-from,
.season-reward-toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(8px);
}

@media (prefers-reduced-motion: reduce) {
  .season-reward-toast-enter-active,
  .season-reward-toast-leave-active {
    transition: none;
  }
}
</style>
